import { Editor } from "@tiptap/core";
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const getPrevText = (
  editor: Editor,
  {
    chars,
  }: {
    chars: number;
  }
) => {
  return editor.state.doc.textContent?.slice(-chars);
};

export function randomElement(array: Array<any>) {
  return array[Math.floor(Math.random() * array.length)];
}

export * from "./cssVar.js";
export * from "./getRenderContainer.js";
export * from "./isCustomNodeSelected.js";
export * from "./isTextSelected.js";
